export default "__VITE_ASSET__Dus3arIi__"